<div class="container-fluid">
    <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
            <span class="subtitles me-5">{{"SYSTEM.READONLY.NAME" | translate}}: </span>
            <p class="content">{{stepOne?.customer_name}}</p>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <span class="subtitles me-5">{{"SYSTEM.READONLY.SURNAME" | translate}}: </span>
            <p class="content">{{stepOne?.customer_surname}}</p>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <span class="subtitles me-5">{{"SYSTEM.READONLY.PHONE" | translate}}: </span>
            <p class="content">{{stepOne?.customer_phone}}</p>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <span class="subtitles me-5">{{"SYSTEM.READONLY.COUNTRY" | translate}}: </span>
            <p class="content">{{country_name}}</p>
        </div>
        <div *ngIf="stepOne?.customer_country !== 12; else italianBlock" class="col-12 col-md-6 col-lg-3">
            <span class="subtitles me-5">{{"SYSTEM.READONLY.LICENSENUMBER" | translate}}: </span>
            <p class="content">{{stepOne?.customer_licensenumber}}</p>
        </div>
        <ng-template #italianBlock>
            <div class="col-12 col-md-6 col-lg-4">
                <span class="subtitles me-5">{{"SYSTEM.READONLY.FISCALCODE" | translate}}: </span>
                <p class="content">{{stepOne?.customer_fiscalcode}}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <span class="subtitles me-5">{{"SYSTEM.READONLY.VAT" | translate}}: </span>
                <p class="content">{{stepOne?.customer_vat}}</p>
            </div>
        </ng-template>
    </div>
</div>
